import * as React from "react";
import heroBackground from "../../../assets/hero_background.png"
import heroMain from "../../../assets/hero_main.png"

function HeroSection() {
  return (
    <section className="overflow-hidden text-center">
        <div className="flex overflow-hidden relative flex-col w-full min-h-[762px] max-md:max-w-full">
            <img
            src={heroBackground}
            alt="Background"
            className="object-cover absolute inset-0 size-full"
            />
            <div className="flex relative flex-col justify-center items-center px-8 py-20 w-full bg-white bg-opacity-90 min-h-[762px] max-md:px-5 max-md:max-w-full">
                <header className="flex flex-col justify-center px-16 py-1 max-w-full text-6xl font-bold leading-none text-teal-600 w-[616px] max-md:px-5 max-md:text-4xl">
                    <h1 className="z-10 mt-0 max-md:max-w-full max-md:text-4xl">
                        The Business OS
                    </h1>
                </header>
                <div className="flex flex-col justify-center items-center px-16 py-px mt-6 max-w-full text-3xl leading-none text-amber-500 w-[627px] max-md:px-5">
                    <p className="z-10 max-md:max-w-full">
                        Simplify your business operations
                    </p>
                </div>
                <div className="flex flex-col justify-center px-16 py-2 mt-6 max-w-full text-base font-medium text-white whitespace-nowrap bg-teal-600 rounded-xl w-[181px] max-md:px-5">
                    <button
                        onClick={() => document.getElementById("features").scrollIntoView({ behavior: "smooth" })}
                    >Explore</button>
                </div>
                <img
                    src={heroMain}
                    alt="Business dashboard interface"
                    className="object-contain mt-6 max-w-full aspect-[1.6] w-[627px]"
                />
            </div>
        </div>
    </section>
  );
}

export default HeroSection;
